import toast from 'react-hot-toast';
import { httpRequest } from 'src/services/httpRequest';

export interface UserManagementRow {
  fullName: string;
  email: string;
  phoneNumber: string;
  userRole: string;
  subcodes: unknown;
  status: unknown;
  action: unknown;
}

interface UserData {
  FirstName: string;
  LastName: string;
  EmailID: string;
  PhoneNumber: string;
  UserRole: string;
  InspectorProfile: any;
  UserID: number;
}

export const columns = [
  'Full Name',
  'Email',
  'Phone Number',
  'User Role',
  'Subcodes',
  'Status',
  'Actions'
];

export const getData = async (
  url: string,
  setState: (data: UserManagementRow[]) => void,
  status: (data: any) => void,
  action: (data: any) => void,
  setLoading: (e: boolean) => void,
  subcodes: (data: any) => void
) => {
  try {
    const response = await httpRequest('GET', url);
    if (response?.status === 'success') {
      const data = await response?.data;
      const Users = data?.map((item: UserData) => {
        return {
          fullName: `${item.FirstName} ${item.LastName}`,
          email: item.EmailID,
          phoneNumber: item.PhoneNumber,
          userRole: item.UserRole,
          subcodes: subcodes(item),
          status: status(item),
          action: action(item)
        };
      });
      setState(Users);
      setLoading(false)
    } else {
      toast.error(response?.message);
      setLoading(false)

    }
  } catch (error) {
    toast.error('An error occurred while fetching permits');
    console.error('Error:', error);
  }
};
